export const CARGROUP_IMAGE_SIZE_DESKTOP = 240;
export const CARGROUP_IMAGE_SIZE_MOBILE = 360;

export const CARLINE_IMG_SIZE_DESKTOP = 332;
export const CARLINE_IMG_SIZE_MOBILE = 480;

export const CARGROUP_HOVER_SCALE = 1.1;
export const CARGROUP_IMAGE_WIDTH = 188;
export const CARGROUP_IMAGE_HEIGHT = 81;
export const CARGROUP_SCALED_IMAGE_WIDTH = Math.ceil(CARGROUP_IMAGE_WIDTH * CARGROUP_HOVER_SCALE);

export const IMAGE_MIME_TYPE = 'webp';

export const ALL_MODELS = 'allModels';
export const NEW = 'new';
